import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useLiveQuizSocket } from "../../contexts/LiveQuizSocketContext";
import { useTranslation } from "../../hooks/useTranslation";

export default function LiveQuizLobby() {
  const { roomCode } = useParams();
  const { socket } = useLiveQuizSocket();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [players, setPlayers] = useState([]);

  useEffect(() => {
    if (!socket) return;

    const doJoin = () => socket.emit("join_room", { roomCode });
    if (socket.connected) {
      doJoin();
    } else {
      socket.once("connect", doJoin);
    }

    const handleHostState = ({ status }) => {
      if (status !== "lobby") {
        navigate(`/livequiz/host/${roomCode}`);
      }
    };

    const handleRoomUpdate = ({ players: playerList }) => {
      setPlayers(playerList || []);
    };

    const handleQuestionStart = () => {
      navigate(`/livequiz/host/${roomCode}`);
    };

    socket.once("host_state", handleHostState);
    socket.on("room_update", handleRoomUpdate);
    socket.on("question_start", handleQuestionStart);

    return () => {
      socket.off("connect", doJoin);
      socket.off("host_state", handleHostState);
      socket.off("room_update", handleRoomUpdate);
      socket.off("question_start", handleQuestionStart);
    };
  }, [socket, roomCode]);

  const startQuiz = () => {
    socket.emit("start_quiz", { roomCode });
    navigate(`/livequiz/host/${roomCode}`);
  };

  return (
    <div className="min-vh-100 bg-primary d-flex flex-column align-items-center justify-content-center text-white p-4">
      <h2 className="fw-bold mb-1">{t.liveQuiz.waitingRoom}</h2>
      <p className="opacity-75 mb-4">
        {t.liveQuiz.roomCode} <strong className="fs-4 font-monospace">{roomCode}</strong>
      </p>
      <div className="bg-white bg-opacity-10 rounded-3 p-4 mb-4 w-100" style={{ maxWidth: 600 }}>
        <p className="mb-3 fw-semibold">
          {t.liveQuiz.studentsJoined.replace("{{count}}", players.length)}
        </p>
        <div className="d-flex flex-wrap gap-2">
          {players.map((p, i) => (
            <span key={i} className="badge livequiz-lobby-player-badge bg-white text-primary fs-6 px-3 py-2">
              {p.name}
            </span>
          ))}
        </div>
      </div>
      <button
        className="btn btn-light btn-lg px-5 fw-bold text-primary"
        onClick={startQuiz}
        disabled={players.length === 0}
      >
        ▶ {t.liveQuiz.startQuiz.replace("{{count}}", players.length)}
      </button>
    </div>
  );
}
